import { get } from 'app/utils/axios/kheti'
import {FarmerLivestock, Livestock} from "../models/farmer";

const fetchFarmerLivestocks = async (farmerId: string) => {
  try {
    const url = `/farmer-360/v1/farmer/${farmerId}/livestock`;
    const response = await get<FarmerLivestock[]>(url);
    return Object.entries(response)
        .filter(([key]) => key !== "api-trace-id")
        .map(([, value]) => value) as FarmerLivestock[];
  } catch (e) {
    return [];
  }
};

export default fetchFarmerLivestocks;
